export const initialOptions: RequestInit = {
  method: 'POST',
  mode: 'cors',
  cache: 'no-cache' as RequestCache,
  credentials: 'same-origin',
  headers: {
    'Content-Type': 'application/json',
    Authorization: process.env.REACT_APP_API_KEY || '',
  },
  redirect: 'follow',
  referrerPolicy: 'no-referrer',
};
